module.exports = __webpack_public_path__ + "static/img/40-1.92577c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/40-1.jpg
// module id = vVAf
// module chunks = 0